// extracted by mini-css-extract-plugin
var _1 = "ReactQuill-module__animatedBackground--zj9EW";
var _2 = "ReactQuill-module__autoHeight--koE4o";
var _3 = "ReactQuill-module__container--dzyhn";
var _4 = "ReactQuill-module__embedSelectionContainer--eM08B";
var _5 = "ReactQuill-module__noPadding--aurgv";
var _6 = "ReactQuill-module__quillContainer--mJ5le";
var _7 = "ReactQuill-module__smallTitleSize--nW0jH";
export { _1 as "animatedBackground", _2 as "autoHeight", _3 as "container", _4 as "embedSelectionContainer", _5 as "noPadding", _6 as "quillContainer", _7 as "smallTitleSize" }
